import { render, staticRenderFns } from "./previewPoster.vue?vue&type=template&id=288923b4&scoped=true&"
import script from "./previewPoster.vue?vue&type=script&lang=js&"
export * from "./previewPoster.vue?vue&type=script&lang=js&"
import style0 from "./previewPoster.vue?vue&type=style&index=0&id=288923b4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288923b4",
  null
  
)

export default component.exports